import { useSWR } from '@tiger/swr';
import { Skeleton } from 'antd';
import { Helmet } from 'react-helmet';
import { useParams, useSearchParams } from 'react-router-dom';
import EntryContent from 'components/EntryContent';
import ErrorBox from 'components/ErrorBox';
import API from 'utils/API';
import './style.scss';

interface AgreementProps {
    isAgreement?: boolean;
}

const Agreement: React.FC<AgreementProps> = ({ isAgreement }) => {
    const [searchParams] = useSearchParams();
    const legal_version = searchParams.get('legal_version');
    const id = useParams().id!;

    const { isLoading, mutate, data, error } = useSWR(
        {
            url: isAgreement ? API.CUSTOMER.agreement(id) : API.CUSTOMER.statement(id),
            params: legal_version ? { legal_version } : {}
        },
        {
            dataChain: res => res.data,
            immutable: true
        }
    );

    const render = () => {
        if (error && !data) {
            return <ErrorBox error={error} onClick={() => mutate()} />;
        }

        if (isLoading) {
            return (
                <>
                    <Skeleton
                        active
                        style={{
                            marginBottom: 30
                        }}
                    />
                    <Skeleton active />
                </>
            );
        }

        return <EntryContent content={data && typeof data.content === 'string' ? data.content : data} />;
    };

    return (
        <div className="agreement-root">
            <Helmet>
                <title>{data?.title || 'Agreements & Disclosures'}</title>
            </Helmet>
            {render()}
        </div>
    );
};

export default Agreement;
